import { useEffect } from 'react';
import { HeadWrapper, Wrapper, Head, Title } from './users-management-page.styles';
import { Button } from '@vtbhome/juicyfront';
import { FilterManagementUsers } from '@features/user/filter-management-users/ui/filter-management-users';
import { ArrowsChevronLeft } from '@vtbhome/juicyfront/indexIcon';
import { useHistory } from 'react-router-dom';
import { ListUsersManagement } from '@widgets/list-users-management/ui/list-users-management';
import { useUsersListSharedQuery } from '@entities/user/libs/hooks/use-users-list-shared-query/use-users-list-shared-query';
import { DEFAULT_USERS_LIST_PARAMETERS } from '@entities/user/config/store-constants';
import { UsersListManagemntDataRequest } from '@entities/user/api/user-management-types';
import { SortUsersByAlphabet } from '@features/user/sort-users-by-alphabet/ui/sort-users-by-alphabet';
import { useSearchParams } from '@shared/lib/hooks/use-search-params/use-search-params';

export const UsersManagementPage = () => {
    const [usersListParameters, setUsersListParameters] = useSearchParams<UsersListManagemntDataRequest>({
        ...DEFAULT_USERS_LIST_PARAMETERS,
        order: 'fullName',
        companies: [],
    });
    const [getUsers, getUsersResult] = useUsersListSharedQuery(usersListParameters);
    const history = useHistory();
    const usersListLength = getUsersResult.isSuccess ? getUsersResult.data?.total || 0 : undefined;

    useEffect(() => {
        getUsers(usersListParameters);
    }, [usersListParameters]);

    return (
        <Wrapper>
            <HeadWrapper>
                <Head>
                    {Boolean(history.length) && (
                        <Button
                            round
                            size='xl'
                            buttonType='secondary'
                            startAdornment={<ArrowsChevronLeft />}
                            onClick={() => history.goBack()}
                        />
                    )}
                    <Title size='h6'>
                        Управление пользователями {Boolean(usersListLength) && `(${usersListLength})`}
                    </Title>
                    <FilterManagementUsers
                        usersListParameters={usersListParameters}
                        setUsersListParameters={setUsersListParameters}
                    />
                </Head>
                <SortUsersByAlphabet parameters={usersListParameters} setParameters={setUsersListParameters} />
            </HeadWrapper>
            <ListUsersManagement
                usersListParameters={usersListParameters}
                setUsersListParameters={setUsersListParameters}
            />
        </Wrapper>
    );
};
